import axiosService from './common/axios'

function searchStblTitle (paramData) {
  return axiosService.get('subject/stbl/selectStblTitle', { params: paramData })
}

function searchStblHeaderList (paramData) {
  return axiosService.get('subject/stbl/selectPivotHeaderList', { params: paramData })
}

function searchStblDataList (paramData) {
  return axiosService.get('subject/stbl/selectPivotDataList', { params: paramData })
}

function searchColItemList (params) {
  const paramData = {}
  Object.assign(paramData, params)
  paramData.dsgnItemCode = 'CODE-1017906'
  return axiosService.get('subject/stbl/selectPivotItemList', { params: paramData })
}

function searchRowItemList (params) {
  const paramData = {}
  Object.assign(paramData, params)
  paramData.dsgnItemCode = 'CODE-1017907'
  return axiosService.get('subject/stbl/selectPivotItemList', { params: paramData })
}

function searchColItemTitleList (params) {
  const paramData = {}
  Object.assign(paramData, params)
  paramData.dsgnItemCode = 'CODE-1017906'
  return axiosService.get('subject/stbl/selectPivotTitleList', { params: paramData })
}

function searchRowItemTitleList (params) {
  const paramData = {}
  Object.assign(paramData, params)
  paramData.dsgnItemCode = 'CODE-1017907'
  return axiosService.get('subject/stbl/selectPivotTitleList', { params: paramData })
}
// 주제별 통계 조회
function selectPivotStblInfo (params) {
  const paramData = {}
  Object.assign(paramData, params)
  return axiosService.get('subject/stbl/selectPivotStblInfo', { params: paramData })
}
// 주제별 통계-> 주요관광지 통계 조회
function selectPivotStblTouristInfo (params) {
  const paramData = {}
  Object.assign(paramData, params)
  return axiosService.get('subject/stbl/selectPivotStblTouristInfo', { params: paramData })
}

// 주제별 통계-> 주요관광지 통계 조회 (소계 처리)
function selectPivotStblTouristSubSumInfo (params) {
  const paramData = {}
  Object.assign(paramData, params)
  return axiosService.get('subject/stbl/selectPivotStblTouristSubSumInfo', { params: paramData })
}

// 기본정보 조회
function selectBasicInfo (paramData) {
  return axiosService.get('subject/selectBasicInfo', { params: paramData })
}

// 지표통계 조회
function selectPivotStblIndexInfo (params) {
  const paramData = {}
  Object.assign(paramData, params)
  return axiosService.get('subject/stbl/selectPivotStblIndexInfo', { params: paramData })
}

// 지표통계 조회
function saveDownloadHistory (params) {
  const paramData = {}
  Object.assign(paramData, params)
  return axiosService.get('subject/stbl/saveDownloadHistory', { params: paramData })
}


export { searchStblTitle, searchStblHeaderList, searchStblDataList, searchColItemList, searchRowItemList
  , searchColItemTitleList, searchRowItemTitleList, selectPivotStblInfo, selectBasicInfo, selectPivotStblIndexInfo, selectPivotStblTouristInfo
  ,selectPivotStblTouristSubSumInfo, saveDownloadHistory
}
